<div
  *ngIf="status || loading"
  class="status-split-dropdown"
  data-testid="entity-status-badge"
  [class.is-open]="open"
  (click)="toggleFromWrapper()"
  (keydown)="onKey($event)"
  [attr.tabindex]="disabled ? -1 : 0"
  role="button"
  aria-haspopup="listbox"
  [attr.aria-expanded]="open"
  [class.disabled]="disabled"
  [class.loading]="loading"
>
  <ng-container *ngIf="loading; else contentMode">
    <div class="sub-status-text">Loading...</div>
  </ng-container>
  <ng-template #contentMode>
    <div class="primary-tag" data-testid="status-primary-tag" [attr.data-status]="normalizedStatus">
      {{ primaryPart }}
    </div>
    <div class="sub-status-text" data-testid="status-sub-tag" *ngIf="hasSubStatus">
      {{ dropdownSelected }}
    </div>
    <span *ngIf="!disabled" class="material-symbols-outlined chevron" aria-hidden="true">
      {{ open ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </span>
  </ng-template>
  <div *ngIf="open && !loading && !disabled" class="split-menu" role="listbox">
    <div
      *ngFor="let item of dropdownItems"
      class="split-menu__option"
      role="option"
      [attr.aria-selected]="item === dropdownSelected"
      [class.active]="item === dropdownSelected"
      (click)="onSelect(item); $event.stopPropagation()"
    >
      {{ item }}
    </div>
  </div>
</div>
